import { TransactionList } from '@/api/blocks/interface'
import TransactionCard from '../cardInfoTwo'
import MeEmpty from '@/components/MeEmpty'
import styles from './index.module.less'
import LoadingCom from '@/components/LoadingCom'
import classNames from 'classnames'

const TransactionCardList = ({
  blockTxs,
  loading,
}: {
  blockTxs: TransactionList[]
  loading: boolean
}) => {
  return (
    <div className={styles.wrap}>
      {loading ? <LoadingCom></LoadingCom> : null}
      {blockTxs.length === 0 && (
        <div
          className={classNames({
            [styles.emptyLoading]: loading,
          })}
        >
          <MeEmpty />
        </div>
      )}
      {blockTxs.map((item, index) => (
        <TransactionCard key={`${item.hash}${index}`} cardData={item as any} />
      ))}
    </div>
  )
}

export default TransactionCardList
